/**
 * Environment configuration for podcast URLs
 * Handles local development vs production S3 URLs
 */

// Environment detection
export const isDevelopment = process.env.NODE_ENV === 'development';
export const isProduction = process.env.NODE_ENV === 'production';

// Base URLs for different environments
export const PODCAST_BASE_URLS = {
  development: process.env.REACT_APP_LOCAL_PODCAST_URL || 'http://localhost:3001/podcasts',
  production: process.env.REACT_APP_CLOUDFRONT_URL || 'https://archives.smndiaye.com',
  test: 'http://localhost:3001/podcasts'
};

// Get current environment's base URL
export const getPodcastBaseUrl = () => {
  return PODCAST_BASE_URLS[process.env.NODE_ENV] || PODCAST_BASE_URLS.development;
};

// Convert S3 URL to appropriate environment URL
export const convertPodcastUrl = (s3Url) => {
  if (!s3Url) return '';
  
  const baseUrl = getPodcastBaseUrl();
  
  // If already a full URL for current environment, return as-is
  if (s3Url.startsWith(baseUrl)) {
    return s3Url;
  }
  
  // Extract the path from S3 URL
  const s3Pattern = /https:\/\/([^.]+)\.s3\.amazonaws\.com\/(.+)/;
  const match = s3Url.match(s3Pattern);
  
  if (match) {
    const [, , path] = match;
    return `${baseUrl}/${path}`;
  }
  
  // If it's already a relative path, prepend base URL
  if (s3Url.startsWith('/')) {
    return `${baseUrl}${s3Url}`;
  }
  
  // If it doesn't start with http/https, assume it's a relative path
  if (!s3Url.startsWith('http')) {
    return `${baseUrl}/${s3Url}`;
  }
  
  // Fallback: return original URL
  return s3Url;
};

// Configuration for different deployment environments
export const DEPLOYMENT_CONFIG = {
  development: {
    podcastBaseUrl: 'http://localhost:3001/podcasts',
    apiBaseUrl: 'http://localhost:3000',
    enableCORS: true,
    enableMockData: process.env.REACT_APP_ENABLE_MOCK === 'true'
  },
  staging: {
    podcastBaseUrl: process.env.REACT_APP_S3_PODCAST_BASE_URL || 'https://staging-podcast-bucket.s3.amazonaws.com',
    apiBaseUrl: process.env.REACT_APP_API_BASE_URL,
    enableCORS: false,
    enableMockData: false
  },
  production: {
    podcastBaseUrl: process.env.REACT_APP_CLOUDFRONT_URL || 'https://archives.smndiaye.com',
    apiBaseUrl: process.env.REACT_APP_API_BASE_URL || 'https://api.archives.smndiaye.com',
    enableCORS: false,
    enableMockData: false
  }
};

// Get current deployment configuration
export const getDeploymentConfig = () => {
  const env = process.env.REACT_APP_DEPLOY_ENV || process.env.NODE_ENV || 'development';
  return DEPLOYMENT_CONFIG[env] || DEPLOYMENT_CONFIG.development;
};

export default {
  isPodcastUrlLocal: () => getPodcastBaseUrl().includes('localhost'),
  convertPodcastUrl,
  getPodcastBaseUrl,
  getDeploymentConfig
};